import { uniqueId } from 'lodash';
import { url } from 'configs/';
import notificationIcon from '../../images/links/py/icon_payroll_notification.svg';
const baseUrl = url.PY_API_SERVER;
const module = 'PY';
export default [
  {
    id: uniqueId(),
    module,
    i18nKey: 'SH_MyPayslip',
    icon: notificationIcon,
    url: '/payroll/salarysearchprint',
    messageApi: `${baseUrl}/PayrollNotices/MessageCount`,
    sort: 15,
    onlySupervisor: false,
  },
];



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/420/s/Tube.Frontend/src/containers/App/screens/Tube/screens/Index/config/links/py.js
 **/